module.exports = __webpack_public_path__ + "static/media/b42@2x.05633b76.png";